module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c(_vm.activeComponent, {
    tag: "div",
    attrs: {
      "model": _vm.model,
      "action": _vm.action,
      "id": _vm.id,
      "root-config": _vm.rootConfig,
      "config": _vm.config,
      "siteId": _vm.siteId,
      "permitted-sites-config": _vm.permittedSitesConfig
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49b400fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueCrud.vue
// module id = 535
// module chunks = 1